export default __webpack_public_path__ + "c72ba0fb7032eef26165bece4647ba51.coffee";